import React, { useCallback, useEffect, useState } from 'react';
import { Box, Container, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import api, { ENGINE } from '../../infrastructure/config/api';
import Button from '../components/common/Button';
import { EnginePositionsTable, EngineSummaryCards } from '../components/engine';

const EnginePositions = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [symbol, setSymbol] = useState('BTCUSDT');
  const [includeClosed, setIncludeClosed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchPositions = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(ENGINE.POSITIONS, {
        params: { symbol, includeClosed },
      });
      setData(response.data?.data || null);
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || 'Failed to load engine positions', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, includeClosed, symbol]);

  useEffect(() => {
    fetchPositions();
  }, [fetchPositions]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4">Engine Positions</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField
          label="Symbol"
          size="small"
          value={symbol}
          onChange={(e) => setSymbol(String(e.target.value || '').toUpperCase())}
        />
        <FormControlLabel
          control={<Switch checked={includeClosed} onChange={(e) => setIncludeClosed(e.target.checked)} />}
          label="Include closed"
        />
        <Button variant="contained" onClick={fetchPositions} loading={loading}>Refresh</Button>
      </Box>

      <Box sx={{ mb: 2 }}>
        <EngineSummaryCards summary={data?.summary} />
      </Box>
      <EnginePositionsTable rows={data?.runningTrades || []} />
    </Container>
  );
};

export default EnginePositions;
